import { z } from 'zod';

import localStorageObjectSchema from 'common/zod/localStorageObjectSchema';

export const USER_CARD_ACTIVATION = 'userCardActivation';

export const cardActivationDataSchema = z.record(
  z.object({
    shouldAutoOrderVirtualCard: z.boolean(),
  }),
);

const getVirtualCardActivationDataFromLocalStorage = (
  companyUserId: string | undefined,
): boolean => {
  if (!companyUserId) {
    return false;
  }

  const existingUsersCardActivation = localStorageObjectSchema
    .pipe(cardActivationDataSchema)
    .safeParse(window.localStorage.getItem(USER_CARD_ACTIVATION));

  const usersCardActivation = existingUsersCardActivation.success
    ? existingUsersCardActivation.data
    : {};

  // @ts-expect-error Type 'boolean | null' is not assignable to type 'boolean'.
  return usersCardActivation[companyUserId]?.shouldAutoOrderVirtualCard ?? null;
};

export const saveVirtualCardActivationDataFromLocalStorage = (
  companyUserId: string | undefined,
  data: {
    shouldAutoOrderVirtualCard: boolean;
  },
): void => {
  if (!companyUserId) {
    return;
  }

  const existingUsersCardActivation = localStorageObjectSchema
    .pipe(cardActivationDataSchema)
    .safeParse(window.localStorage.getItem(USER_CARD_ACTIVATION));

  const usersCardActivation = existingUsersCardActivation.success
    ? existingUsersCardActivation.data
    : {};

  usersCardActivation[companyUserId] = data;

  window.localStorage.setItem(
    USER_CARD_ACTIVATION,
    JSON.stringify(usersCardActivation),
  );
};

export const useVirtualCardActivationDataFromLocalStorage = (
  companyUserId: string | undefined,
): boolean => {
  if (!companyUserId) {
    return false;
  }
  return getVirtualCardActivationDataFromLocalStorage(companyUserId);
};
